import React, { useState } from 'react';
import { Button, Modal, Tabs, Space, message } from 'antd';
import { PlusOutlined, TeamOutlined } from '@ant-design/icons';
import {
  usePartnerDoctors,
  useDissociateDoctor,
  useAssociateDoctors,
} from '../hooks';
import { AssociatedDoctorsList, DoctorAssociation } from '../components/doctors';

const DoctorsTab = ({ partnerId }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDoctorIds, setSelectedDoctorIds] = useState([]);

  const { data, isLoading, refetch } = usePartnerDoctors(partnerId);
  const dissociateDoctor = useDissociateDoctor();
  const associateDoctors = useAssociateDoctors();

  const doctors = data?.data || [];

  const handleAdd = () => {
    setSelectedDoctorIds([]);
    setIsModalVisible(true);
  };

  const handleRemove = async (doctorId) => {
    await dissociateDoctor.mutateAsync({ partnerId, doctorId });
    refetch();
  };

  const handleAssociate = async () => {
    if (selectedDoctorIds.length === 0) {
      message.warning('Please select at least one doctor to associate');
      return;
    }

    try {
      await associateDoctors.mutateAsync({
        partnerId,
        doctorIds: selectedDoctorIds,
      });
      setIsModalVisible(false);
      refetch();
    } catch (error) {
      console.error('Error associating doctors:', error);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedDoctorIds([]);
  };

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Space>
          <TeamOutlined style={{ fontSize: 20 }} />
          <span style={{ fontSize: 16, fontWeight: 500 }}>
            {doctors.length} doctor(s) associated
          </span>
        </Space>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
          Associate Doctors
        </Button>
      </div>

      <AssociatedDoctorsList
        doctors={doctors}
        loading={isLoading}
        onRemove={handleRemove}
      />

      <Modal
        title="Associate Doctors with Partner"
        open={isModalVisible}
        onCancel={handleCancel}
        width={1000}
        footer={
          <Space>
            <Button onClick={handleCancel}>Cancel</Button>
            <Button
              type="primary"
              onClick={handleAssociate}
              loading={associateDoctors.isLoading}
            >
              Associate Selected Doctors
            </Button>
          </Space>
        }
        destroyOnClose
      >
        <DoctorAssociation
          partnerId={partnerId}
          onAssociate={(doctorIds) => setSelectedDoctorIds(doctorIds)}
        />
      </Modal>
    </div>
  );
};

export default DoctorsTab;
